import React from "react";
import Cat from "../icons/cat.svg";
import User from "../icons/user.png";
import Search from "../icons/searchIconBlack.png";
import Virus from "../icons/virus.png";

const AboutModal = ({ closeModal }) => {
  return (
    <div className="about-modal">
      <button className="close-btn" onClick={closeModal}>
        X
      </button>
      <div className="about-container">
        <p className="about-para">
          Anyone who knows me knows that I am obsessed with cats, but don't have
          a <img src={Cat} alt="cat-icon" className="icon-sm" /> of my own.
          During <img src={Virus} alt="virus-icon" className="icon-sm" />{" "}
          lockdown, I found myself photographing neighbourhood cats on my daily
          mandated walk. I wanted a way to share that joy with other people and
          to be able to locate on a map where and when the cats were seen. And
          thus, <span className="bold-text-title">kittymapper</span> was born.
        </p>
        <div className="instructions">
          <p className="about-para">
            <img src={Cat} alt="cat-icon" className="icon-sm" /> Click on a pin
            to view a cat
          </p>
          <p className="about-para">
            <img src={User} alt="user-icon" className="icon-sm" /> Create an
            account and start sharing your favourite felines
          </p>
          <p className="about-para">
            <img src={Search} alt="search-icon" className="icon-sm" /> Locate
            new furry friends anywhere in the world
          </p>
        </div>
        <p className="small-print">
          <span className="bold-text">The nerdy bits:</span> Built with Rails
          API, JWT authentication, React, Google Maps API and AWS S3. On upload,
          the image's EXIF data is read. If GPS coordinates are present in the
          data, a pin is automatically plotted on the map. AWS Rekognition
          software is used to detect the contents of the photo; in other words,
          no dogs allowed!
        </p>
        <p className="small-print">
          <span className="bold-text">kittymapper</span> is built by{" "}
          <a
            href="https://www.lilawalker.dev"
            className="website-link"
            target="blank"
          >
            lila walker
          </a>
        </p>
      </div>
    </div>
  );
};

export default AboutModal;
